<script setup>
import { useSlots } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  showActionButton: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['click', 'close']);
const slots = useSlots();

const handleButtonClick = () => {
  emit('click');
};
</script>

<template>
  <section class="flex h-full w-full flex-col overflow-hidden bg-n-surface-1">
    <header
      class="sticky top-0 z-10 border-b border-n-alpha-3 bg-n-surface-1/95 px-6 backdrop-blur-sm lg:px-0"
    >
      <div class="mx-auto w-full max-w-[72rem]">
        <div class="flex h-20 w-full items-center justify-between gap-3">
          <span class="text-xl font-semibold text-n-slate-12">
            {{ headerTitle }}
          </span>

          <slot name="header-actions" />

          <div
            v-if="showActionButton"
            v-on-clickaway="() => emit('close')"
            class="relative group/campaign-button"
          >
            <Button
              :label="buttonLabel"
              icon="i-lucide-plus"
              size="sm"
              class="group-hover/campaign-button:brightness-110"
              @click="handleButtonClick"
            />
            <slot name="action" />
          </div>
        </div>
      </div>
    </header>

    <main class="flex-1 overflow-y-auto px-6 lg:px-0">
      <div class="mx-auto w-full max-w-[72rem] py-5">
        <div
          v-if="slots.hero"
          class="mb-4 rounded-2xl border border-n-alpha-3 bg-gradient-to-r from-n-blue-2/40 via-transparent to-n-teal-2/30 p-4"
        >
          <slot name="hero" />
        </div>

        <slot name="default" />
      </div>
    </main>
  </section>
</template>
